import ConfigurableFlexContainer from './_configurable-flex-container.js'

export default {
  name: 'FlexContainerBase',
  values: {
    display: 'flex',
    $mixin: [
      {
        configSet: ConfigurableFlexContainer,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
